import Vue from 'vue'
import moment from 'moment'

export default class DateTime {

    static #dateFormat = 'YYYY-MM-DD'
    static #dateTimeFormat = 'YYYY-MM-DD HH:mm:ss'

    static format (v, utcOffset = null, format = DateTime.#dateTimeFormat) {
        let m = moment(v)
        if (!m.isValid()) {
            throw new Error('invalid date/time value.')
        }

        if (utcOffset !== null) {
            if (typeof utcOffset !== 'number') {
                throw new Error('utc offset must be a number of minutes.')
            }
            m.utcOffset(parseInt(utcOffset))
        } else {
            m.local()
        }

        return m.format(format)
    }

    static getDateFormat () {
        return window.i18n.t(DateTime.#dateFormat)
    }

    static getDateTimeFormat () {
        return window.i18n.t(DateTime.#dateTimeFormat)
    }

}

Vue.filter(
    'datetime_format',
    (v, offset = null, format = DateTime.getDateTimeFormat()) => DateTime.format(v, offset, format)
)
Vue.filter(
    'date_format',
    (v, offset = null, format = DateTime.getDateFormat()) => DateTime.format(v, offset, format)
)
Vue.prototype.$datetime = DateTime
